export default "__VITE_ASSET__CfpU5pca__"